<div class="home-page container py-5">
  <div class="row">
    <div class="col-md-8 offset-md-2">
      <div class="text-center">
        <h1>{{ 'APP_NAME' | translate }}</h1>
        <p class="lead mt-3">{{ 'WELCOME' | translate }}@if (currentUser?.nickname || currentUser?.name) {<span>, {{ currentUser?.nickname || currentUser?.name }}</span>}!</p>
        </div>

        <div class="settings-panel mt-5 p-4 border rounded">
          <h2 class="h5 mb-4">{{ 'THEME' | translate }} & {{ 'LANGUAGE' | translate }}</h2>

          <div class="mb-3">
            <app-theme-selector></app-theme-selector>
          </div>

          <div class="mb-3">
            <app-language-selector></app-language-selector>
          </div>

          <div class="mb-3">
            <app-theme-package-selector></app-theme-package-selector>
          </div>
        </div>
      </div>
    </div>
  </div>
